import Footer from "../Common/Footer";
import Header from "../Common/Header";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { use, useContext, useEffect } from "react";
import { getRecords, PostRecords } from "../Services/ApiCall";
import FeaturedProperty from "../Common/FeaturedProperties";
import Projects from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";
import { LoggedInUserID, LoggedInUserName } from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";
import { buildFilterString, generate4DigitId } from "../Services/Helper";
import { useState } from "react";
import { TailSpin } from "react-loader-spinner";
import SidebarFilter from "../Common/SidebarFilter";
import { Drawer } from "@mui/material";
import Conversation from ".././lotties/Conversation.json";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Lottie from "lottie-react";

import NoData from ".././lotties/NoData.json";

function Chats() {
  const {
    logindata,

    userData,
  } = useContext(ApiContext);
  // const filters = location?.state?.filters;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const chatID = params.get("chatID") ?? null;

  const [chatListData, setChatListData] = useState([]);
  const [ChatMsg, setChat] = useState([]);

  const [Msg, setMsg] = useState("");

  const [Loading, setLoading] = useState(true);

  const [selectedChat, setSelectedChat] = useState(null);

  const chatList = [
    {
      id: 1,
      name: "Rahul Sharma",
      lastMessage: "Is the flat still available?",
      messages: [
        { from: "them", text: "Hi, is the flat still available?" },
        { from: "me", text: "Yes, it is available." },
        { from: "them", text: "Can I schedule a visit?" },
      ],
    },
    {
      id: 2,
      name: "Priya Verma",
      lastMessage: "Please share brochure",
      messages: [
        { from: "them", text: "Please share brochure" },
        { from: "me", text: "Sure, sending now." },
        { from: "them", text: "Please share brochure" },
        { from: "me", text: "Sure, sending now." },
        { from: "them", text: "Please share brochure" },
      ],
    },
  ];

  const activeChat = chatList[selectedChat];

  useEffect(() => {
    getChatList();
  }, []);

  const getChatList = () => {
    getRecords(
      414,
      1000,
      `{\$or: [{'UserID': ${LoggedInUserID}}, {'OwnerID': ${LoggedInUserID}}]}`,
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false) {
            setChatListData(data?.response?.records || []);

            if (chatID != null) {
              const selected = (data?.response?.records || []).find(
                (chat) => chat?.ChatID.toString() === chatID.toString(),
              );
              setSelectedChat(selected || null);
              if (selected != null) {
                getChatMessages(selected?.ChatID);
              }
            }
            setLoading(false);
          } else {
            console.log("Error in fetching chat list", data);
          }
        }
      },
    );
  };

  const getChatMessages = (chatID) => {
    // setLoading(true);
    getRecords(415, 1000, `{'ChatID':{\$eq:${chatID}}}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false) {
          setChat(data?.response?.records || []);
          //  setLoading(false);
        } else {
          console.log("Error in fetching chat messages", data);
        }
      }
    });
  };

  const SendMsg = () => {
    let msgbody = [
      {
        ChatID: selectedChat?.ChatID,
        ListingID: selectedChat?.ListingID,
        SenderID: LoggedInUserID,
        SenderName: userData?.User || "User",
        ReceiverID: selectedChat?.OwnerID,
        ReceiverName: selectedChat?.OwnerName || "Owner",
        Msg: Msg,
        Type: "text",
        Url: "",
      },
    ];

    let updatedChat = { ...msgbody[0], MsgID: generate4DigitId() };
    setChat((prev) => [updatedChat, ...prev]);

    setMsg("");

    PostRecords(415, 1, msgbody, (resp) => {
      if (resp != null && resp?.response?.hasErrors === false) {
        // navigate("/chats?chatID=" + res?.response?.response?.clientID);
      } else {
        //  setLoading(false);
      }
    });
  };

  // console.log("Filters in ViewAllListing:", tabID, filters);
  return (
    <>
      <div className="page-wrapper">
      <Header />

      <div
        style={{
          height: "95vh",
          display: "flex",
          backgroundColor: chatListData.length !== 0 ? "#f2fff4" : "white",
          fontFamily: "Arial, sans-serif",
        }}

        className="chatbody"
      >
        {chatListData.length !== 0 ? (
          <>
            {" "}
            {/* LEFT CHAT LIST */}
            <div
              style={{
                width: window.innerWidth < 768 ? "30%" : "30%",
                borderRight: "1px solid #e5e7eb",
                backgroundColor: "white",
                display:
                  window.innerWidth < 768 && selectedChat !== null
                    ? "block"
                    : "block",
              }}
            >
              <div
                style={{
                  padding: "8px 16px",
                  fontWeight: "bold",
                  fontSize: "18px",
                  color: "#16a34a",
                }}
              >
                <input type="text" className="chatsearch" placeholder="Search" />
              </div>
              <div className="chatgrey">   <span className="bg-grey">All</span>
            <span className="bg-grey">Buying</span>
            <span className="bg-grey">Selling</span></div>
              {chatListData?.map((chat, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setSelectedChat(chat);
                    getChatMessages(chat?.ChatID);
                  }}
                  style={{
                    padding: "14px 16px",
                    cursor: "pointer",
                    display:'flex',
                    borderBottom: "1px solid #f0f0f0",
                    backgroundColor:
                      selectedChat?.ChatID === chat?.ChatID
                        ? "#f2fff4"
                        : "white",
                  }}
                >
                 
                      <div><div className="developer">
                            <img src="assets/img/lplogo.jpg" alt="Image" />

                            <i class="ri-shield-check-fill text-white icnss"></i>
                          </div></div>

                  <div>
                     <div style={{ fontWeight: "600", display:'flex', justifyContent:'space-between'}}>
                    {chat?.UserID == LoggedInUserID
                      ? chat?.OwnerName
                      : chat?.UserName}

                      <small style={{ marginLeft:10, fontSize:'12px', fontWeight:400}}>12:20Pm</small>
                  </div>
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#6b7280",
                      marginTop: "4px",
                    }}
                  >
                    {chat.PropertyTitle}
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#6b7280",
                      marginTop: "4px",
                    }}
                    className="chatmsg"
                  >
                    {chat.LastMsg}
                  </div>

                  </div>
                </div>
              ))}
            </div>
            {/* RIGHT CHAT AREA */}
            <div
              style={{
                marginTop: 0,
                flex: 1,
                display:
                  window.innerWidth < 768 && selectedChat === null
                    ? "flex"
                    : "flex",
                flexDirection: "column",
                backgroundColor: "#f2fff4",
              }}
            >
              {/* Chat Header */}

              {selectedChat != null && (
                <div
                  style={{
                    padding: "14px 16px",
                    backgroundColor: "white",
                    borderBottom: "1px solid #e5e7eb",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  {/* Profile Image */}
                  <img
                    src={
                      selectedChat?.CoverImage ||
                      "https://dialerpstorageac.blob.core.windows.net/10036/C%3A%5Chome%5Csite%5Cwwwroot%5Cwwwroot%5CAppDocument%5CtempFile%5CActual_1242.jpg"
                    }
                    alt="profile"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />

                  {/* Name & Status */}
                  <div style={{ display: "flex", flexDirection: "column", width:'-webkit-fill-available' }}>
                    <span style={{ fontWeight: "600", fontSize: "15px", display:'flex', alignItems:'center' }}>
                      {selectedChat?.UserID == LoggedInUserID
                        ? selectedChat?.OwnerName
                        : selectedChat?.UserName}
                           <span style={{ fontSize: "12px", color: "#16a34a", marginLeft:5 }}>
                      Online
                    </span>
                    </span>

                    <span className="d-flex" style={{ display: "flex", flexDirection: "row", alignItems:'center', justifyContent:'space-between' }}>
                          <span>2 BHK Apartment in Sec 16, Noida</span>
                          <span style={{ fontSize: "14px", color: "#16a34a", marginLeft:5 }}><b>₹4.00 Lakh</b></span>
                    </span>
                 
                  </div>
                </div>
              )}

              {/* Messages */}
              <div
                style={{
                  flex: 1,
                  padding: "16px",
                  overflowY: "auto",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  backgroundImage: "url('assets/img/output-onlinepngtools.png')"
                 
                }} className="bgchat"
              >
                {selectedChat != null &&
                  [...(ChatMsg || [])]?.reverse()?.map((msg, i) => (
                    <div
                      key={i}
                      style={{
                        alignSelf:
                          msg.SenderID == LoggedInUserID
                            ? "flex-end"
                            : "flex-start",
                        backgroundColor:
                          msg.SenderID == LoggedInUserID ? "#16a34a" : "white",
                        color:
                          msg.SenderID == LoggedInUserID ? "white" : "black",
                        padding: "10px 14px",
                        borderRadius: "18px",
                        maxWidth: "70%",
                        fontSize: "14px",
                      }}
                    >
                      {msg.Msg}
                      <small style={{ marginLeft:10}}>12:20Pm</small>
                    </div>
                  ))}

                {selectedChat === null && (
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ width: 240, height: 240 }}>
                      <Lottie animationData={Conversation} loop={true} />
                    </div>
                  </div>
                )}
              </div>

              {/* Input Area */}

              {selectedChat != null && (
                <div
                  style={{
                    padding: "12px",
                    backgroundColor: "white",
                    borderTop: "1px solid #e5e7eb",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <input
                    value={Msg}
                    onChange={(e) => setMsg(e.target.value)}
                    placeholder="Type a message..."
                    style={{
                      flex: 1,
                      padding: "10px 14px",
                      borderRadius: "20px",
                      border: "1px solid #d1d5db",
                      outline: "none",
                      fontSize: "14px",
                    }}
                  />
                  <button
                    disabled={Msg === ""}
                    onClick={() => {
                      SendMsg();
                    }}
                    style={{
                      backgroundColor: "#16a34a",
                      color: "white",
                      border: "none",
                      padding: "10px 18px",
                      borderRadius: "20px",
                      cursor: "pointer",
                    }}
                  >
                    Send
                  </button>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ width: 240, height: 240 }}>
                <Lottie animationData={NoData} loop={true} />
              </div>
            </div>
          </>
        )}
      </div>

      <Footer />
</div>
      {Loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <TailSpin color="#00BFFF" height={80} width={80} />
        </div>
      )}
    </>
  );
}

export default Chats;
